import React from "react";
import { StyledSwipeableDrawer, StyledTypography } from "../../../../../styled-mui";
import MobileMenuWrapper from "../MobileMenuWrapper";
import { Box } from "@mui/material";
import { ImageLayout } from "../../../../elements/image/ImageLayout";
import SmartLink from "../../../../elements/smart-link/smart-link";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import storeUtil from "../../../../../utils/storeUtil";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
}

const MobileOutilsMenu: React.FC<Props> = ({ open, entireMenuCloseHandler, closeCurrentMenu, menuLinksData }) => {
  const OutilsData = menuLinksData?.outils;
  const universData = OutilsData?.Univers || [];

  const onLinkClick = (item: Record<string, any>) => {
    AsyncCall.sendPageClickCtaEvent({ btn_label: item?.title || "" });
    entireMenuCloseHandler();
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="header-menu-level2 mobile-outils-menu">
      <MobileMenuWrapper
        title="Outils de conception"
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        <Box p={3}>
          {universData?.map((item: Record<string, any>, index: number) => (
            <Box key={item?.name + index} className="configurateur-mobile-entry" mb={6}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                {item?.icon && (
                  <ImageLayout
                    src={storeUtil.getUrlPicture(`${item.icon}`, "")}
                    height={24}
                    width={24}
                    styles={{ margin: "unset" }}
                  />
                )}
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {item?.name}
                </StyledTypography>
              </Box>
              <Box className="configurateur-mobile-links">
                {item?.configurateurs?.map((config: Record<string, any>, index: number) => (
                  <SmartLink
                    key={config?.title + index}
                    isExternal={config?.link?.type === "external"}
                    to={config?.link?.url || ""}
                    onClick={() => onLinkClick(config)}
                    styles={{
                      display: "block",
                      padding: "12px 0px",
                      fontWeight: "500",
                      fontSize: "16px",
                      lineHeight: "100%",
                      color: "rgba(66, 66, 66, 1)",
                    }}>
                    {config?.title}
                  </SmartLink>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobileOutilsMenu;
